<nb-form-field>
  <input nbInput [formControl]="control" fieldSize="small" i18n-placeholder="@@FromTo" [nbPopover]="calendarRef" nbPopoverPlacement="bottom" placeholder="от - до"/>

  <button nbSuffix type="button" [nbPopover]="calendarRef" status="control" nbButton size="small" style="background: none !important">
    <nb-icon icon="calendar-outline"/>
  </button>
</nb-form-field>

<ng-template #calendarRef>
  <tui-calendar-range (valueChange)="dateFilter($event)"/>
</ng-template>
